import React from 'react';

/** Represents a Bible icon used on the Collection Block title */
export const IconBible = (props: React.SVGAttributes<SVGSVGElement>): JSX.Element => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          stroke="currentColor"
          strokeWidth="3"
          d="M23.18 1.5c4.033 0 5.517.367 6.997 1.158a7.607 7.607 0 0 1 3.165 3.165c.791 1.48 1.158 2.964 1.158 6.996v10.362c0 4.032-.367 5.516-1.158 6.996a7.607 7.607 0 0 1-3.165 3.165c-1.48.791-2.964 1.158-6.996 1.158H12.819c-4.032 0-5.516-.367-6.996-1.158a7.607 7.607 0 0 1-3.165-3.165C1.867 28.697 1.5 27.213 1.5 23.18V12.819c0-4.032.367-5.516 1.158-6.996a7.607 7.607 0 0 1 3.165-3.165C7.303 1.867 8.787 1.5 12.82 1.5Z"
        />
        <path
          fill="currentColor"
          fillRule="nonzero"
          d="M12.723 9.005S9 8.748 9 12.09V24.7c0 .994 1.012 2.3 2.362 2.3h12.181c.817 0 1.478-.5 1.478-1.494.586 0 1.978-.025 1.978-1.885V11.999c0-1.42-1.527-2.994-2.995-2.994H12.723Zm9.276 7.88c0 .615-.384.615-.384.615H19v6.128c0 .205-.277.372-.488.372h-1.025c-.211 0-.487-.167-.487-.372V17.5h-2.616s-.384 0-.384-.615v-.992c0-.205.173-.372.384-.372H17v-3.149c0-.205.276-.372.487-.372h1.025c.212 0 .488.167.488.372v3.15h2.615a.38.38 0 0 1 .385.37v.993Z"
        />
      </g>
    </svg>
  );
};
